import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity, Modal, Platform } from 'react-native';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import { colores, fuentes } from '../../styles/variablesCss';

const FeedbackModal = ({
  visible,
  type = 'success', // 'success' | 'error' | 'info'
  title = '',
  message = '',
  confirmText = 'Aceptar',
  onClose,
}) => {
  const isSuccess = type === 'success';
  const isError = type === 'error';

  // En web, evitamos Modal de RNW y renderizamos overlay fijo para evitar problemas de stacking context
  if (Platform.OS === 'web') {
    if (!visible) return null;
    // Cargar createPortal de forma segura sólo en web
    const { createPortal } = require('react-dom');
    return createPortal(
      <View style={styles.overlay} role="dialog" aria-modal="true">
        <View style={styles.content}>
          <View style={styles.iconWrap}>
            <View style={[styles.iconCircle, isSuccess && styles.iconSuccess, isError && styles.iconError]}>
              <MaterialCommunityIcons
                name={isSuccess ? 'check-circle-outline' : isError ? 'alert-circle-outline' : 'information-outline'}
                size={36}
                color={isSuccess ? colores.verde : isError ? colores.rojo : colores.textoPrincipal}
              />
            </View>
          </View>

          {!!title && <Text style={styles.title}>{title}</Text>}
          {!!message && <Text style={styles.message}>{message}</Text>}

          <TouchableOpacity style={[styles.button, isSuccess ? styles.buttonSuccess : isError ? styles.buttonError : styles.buttonNeutral]} onPress={onClose}>
            <Text style={styles.buttonText}>{confirmText}</Text>
          </TouchableOpacity>
        </View>
      </View>,
      document.body
    );
  }

  // Nativo: usar Modal estándar
  return (
    <Modal
      visible={visible}
      transparent={true}
      animationType={'slide'}
      onRequestClose={onClose}
      statusBarTranslucent={true}
      hardwareAccelerated={true}
    >
      <View style={styles.overlay}>
        <View style={styles.content}>
          <View style={styles.iconWrap}>
            <View style={[styles.iconCircle, isSuccess && styles.iconSuccess, isError && styles.iconError]}>
              <MaterialCommunityIcons
                name={isSuccess ? 'check-circle-outline' : isError ? 'alert-circle-outline' : 'information-outline'}
                size={36}
                color={isSuccess ? colores.verde : isError ? colores.rojo : colores.textoPrincipal}
              />
            </View>
          </View>

          {!!title && <Text style={styles.title}>{title}</Text>}
          {!!message && <Text style={styles.message}>{message}</Text>}

          <TouchableOpacity style={[styles.button, isSuccess ? styles.buttonSuccess : isError ? styles.buttonError : styles.buttonNeutral]} onPress={onClose}>
            <Text style={styles.buttonText}>{confirmText}</Text>
          </TouchableOpacity>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  overlay: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.5)',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 16,
    // Forzar que quede por encima de cualquier otro contenido
    zIndex: 9999,
    ...(Platform.OS === 'web'
      ? {
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
        }
      : {
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
        }
    ),
  },
  content: {
    width: '92%',
    maxWidth: 420,
    backgroundColor: colores.blanco,
    borderRadius: 12,
    paddingVertical: 20,
    paddingHorizontal: 18,
    ...(Platform.OS === 'web'
      ? { boxShadow: '0 10px 24px rgba(0,0,0,0.2)' }
      : {
          shadowColor: '#000',
          shadowOffset: { width: 0, height: 8 },
          shadowOpacity: 0.25,
          shadowRadius: 16,
          elevation: 24,
        }),
  },
  iconWrap: {
    alignItems: 'center',
    marginBottom: 8,
  },
  iconCircle: {
    width: 64,
    height: 64,
    borderRadius: 32,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#F2F2F2',
  },
  iconSuccess: {
    backgroundColor: '#E8F5E9',
  },
  iconError: {
    backgroundColor: '#FDECEA',
  },
  title: {
    marginTop: 10,
    marginBottom: 6,
    fontFamily: fuentes.bold,
    fontSize: 18,
    color: colores.textoPrincipal,
    textAlign: 'center',
  },
  message: {
    fontFamily: fuentes.regular,
    fontSize: 14,
    color: colores.textoSecundario,
    textAlign: 'center',
    lineHeight: 20,
    marginBottom: 14,
  },
  button: {
    alignSelf: 'center',
    minWidth: 140,
    borderRadius: 8,
    paddingVertical: 12,
    paddingHorizontal: 18,
    alignItems: 'center',
    justifyContent: 'center',
  },
  buttonSuccess: {
    backgroundColor: colores.rojo, // mantener primario de la web
  },
  buttonError: {
    backgroundColor: colores.rojo,
  },
  buttonNeutral: {
    backgroundColor: colores.textoPrincipal,
  },
  buttonText: {
    color: colores.blanco,
    fontFamily: fuentes.bold,
    fontSize: 15,
  },
});

export default FeedbackModal;
